import React, { useContext } from 'react'
import { Route, Redirect } from 'react-router-dom'
import AuthContext from '../context/auth/authContext'
import { hasLegacyAuthToken, isLotsAuctionCookieAuthEnabled } from '../Utils/authmode'

function PrivateRoute({ component: Component, ...rest }) {
    const authContext = useContext(AuthContext)
    const { isAuthenticated } = authContext
    const isLoggedIn = isLotsAuctionCookieAuthEnabled()
        ? !!isAuthenticated || hasLegacyAuthToken()
        : hasLegacyAuthToken()
    return (
        <Route
            {...rest}
            render={(props) =>
                isLoggedIn ? (
                    <Component {...props} />
                ) : (
                    <Redirect to={{ pathname: '/', state: { referer: props.location } }} />
                )
            }
        />
    )
}

export default PrivateRoute
